import Preview from './Preview'

export default Preview
// eslint-disable-next-line import/export
export * from './Preview'
